export default function Console() {
  return (
    <section id="console">
      <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">Console</h2>

      <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 p-5 space-y-4 text-sm text-slate-600 dark:text-slate-400">
        <p>
          The Console tab shows a real-time log of everything the program is doing — loading data,
          saving changes, errors, and warnings. It's useful for understanding what happened if
          something goes wrong.
        </p>

        <ul className="space-y-2">
          <li><strong className="text-slate-800 dark:text-slate-200">Colour-coded messages</strong> — Info messages, warnings, errors, and success messages are displayed in different colours so you can quickly spot issues.</li>
          <li><strong className="text-slate-800 dark:text-slate-200">Filter by level</strong> — Filter the console output to show only specific message types (e.g. errors only).</li>
          <li><strong className="text-slate-800 dark:text-slate-200">Auto-scroll</strong> — The console automatically scrolls to the latest message. You can turn this off to review older entries.</li>
          <li><strong className="text-slate-800 dark:text-slate-200">Save Log</strong> — Export the full console log to a text file. Helpful when reporting bugs.</li>
          <li><strong className="text-slate-800 dark:text-slate-200">Send Logs</strong> — Anonymously send your console output directly to the developer to help diagnose problems. You'll see exactly what's being sent before confirming, and nothing is shared without your permission.</li>
          <li><strong className="text-slate-800 dark:text-slate-200">Clear</strong> — Clear all console output.</li>
        </ul>

        <div className="rounded-lg border border-blue-200 dark:border-blue-800/50 bg-blue-50 dark:bg-blue-900/20 p-3">
          <p className="text-blue-700 dark:text-blue-400 text-xs">
            If you encounter a bug or unexpected behaviour, use the <strong>Send Logs</strong> button
            to share your console output with the developer, or save the log and post it on Discord.
            Both methods help greatly with diagnosis.
          </p>
        </div>
      </div>
    </section>
  );
}
